module.exports = __webpack_public_path__ + "images/126_4096.jpg";